export default "/imgs/tag/new.svg"